import { useDesignSystem } from 'contexts/design-system'
import FilterPopoverEui from './filterPopover.eui'
import FilterPopoverMui from './filterPopover.mui'
import { FilterPopoverProps } from './types'

export type { FilterPopoverProps } from './types'

export default function FilterPopover( props: FilterPopoverProps ) {
	return useDesignSystem() === 'mui'
		? <FilterPopoverMui {...props} />
		: <FilterPopoverEui {...props} />
}
